import React from "react";

export const BackArrowIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
    <path d="M5.25938 12.375L12.9594 20.075L11 22L0 11L11 0L12.9594 1.925L5.25938 9.625H22V12.375H5.25938Z" fill="#444444"/>
  </svg>
);

export const EditPencilIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
    <path d="M1.26389 10.1111H2.16441L8.34167 3.93385L7.44115 3.03333L1.26389 9.21059V10.1111ZM0 11.375V8.68924L8.34167 0.363368C8.46805 0.247512 8.60761 0.157986 8.76033 0.0947917C8.91305 0.0315972 9.07367 0 9.24219 0C9.41071 0 9.57396 0.0315972 9.73194 0.0947917C9.88993 0.157986 10.0269 0.252778 10.1427 0.379167L11.0116 1.26389C11.138 1.37975 11.2302 1.51667 11.2881 1.67465C11.346 1.83264 11.375 1.99063 11.375 2.14861C11.375 2.31713 11.346 2.47775 11.2881 2.63047C11.2302 2.78319 11.138 2.92274 11.0116 3.04913L2.68576 11.375H0ZM7.88351 3.49149L7.44115 3.03333L8.34167 3.93385L7.88351 3.49149Z" fill="#C78D3C"/>
  </svg>
);
